import styled from "@emotion/styled";
import {
  Box,
  TextField,
  StandardTextFieldProps,
  TextFieldProps,
} from "@mui/material";
import Image from "next/image";
import React from "react";

type InputFieldProps1 = {
  icon: string;
  isIcon?: boolean;
  isTextArea?: boolean;
  labelForm?: string;
};

type InputFieldProps = InputFieldProps1 & TextFieldProps;

const InputWrap = styled(Box)`
  label {
    color: var(--colorE0D6FF);
    margin-bottom: 19px;
    display: block;
    font-size: 14px;
  }
  .form_group {
    position: relative;
    .icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 25px;
      @media (max-width: 575px) {
        left: 15px;
      }
    }
    .MuiOutlinedInput-notchedOutline {
      display: none;
    }
    textarea {
      border: 1px solid rgba(255, 255, 255, 0.3);
      border-radius: 35px;
      color: var(--white);
      padding: 22px 28px;
    }
    .MuiOutlinedInput-root {
      padding: 0;
      .Mui-focused {
        background-color: transparent;
      }
    }
  }
`;

export default function InputField(props: InputFieldProps) {
  const {
    placeholder,
    icon,
    labelForm,
    isIcon = true,
    isTextArea = false,
  } = props;
  return (
    <InputWrap>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      {labelForm ? <label htmlFor="">{labelForm}</label> : null}

      <Box
        // className="form_group"
        className={!isIcon ? "noIconPadding form_group" : "form_group"}
        sx={{
          width: "100%",
          maxWidth: "100%",
        }}
      >
        {isTextArea ? (
          <TextField
            fullWidth
            placeholder={placeholder}
            id="fullWidth"
            multiline
            rows={8}
            maxRows={Infinity}
            {...props}
          />
        ) : (
          <TextField
            fullWidth
            placeholder={placeholder}
            id="fullWidth"
            {...props}
          />
        )}

        {isIcon && (
          <Image alt="" width={20} height={15} src={icon} className="icon" />
        )}
      </Box>
    </InputWrap>
  );
}
